export const IG = () => {
    return (
        <svg
            width="20"
            height="21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="#F8F6DF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 .5a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4H4Zm6 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm6-11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                fill="#F8F6DF"
            />
        </svg>
    );
};
